import { useEffect, useState } from "react";

const RycoViewport = () => {
  const [width, setWidth] = useState(0);
  // Add a second state variable "height" and default it to the current window height
  const [height, setHeight] = useState(0);
  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  useEffect(() => {
    handleWindowResize();

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  return { width, height };
};
export default RycoViewport;
